<div class="container">
    <div class="item">{{ date | date: 'dd-MM-yyyy' }}</div>
    <div class="item">{{ date | date: 'HH:mm' }}</div>
</div>